import _ from 'lodash'

export const getDataAttributes = props => {
	if (_.isEmpty(props)) return

	const dataAttributes = _.pickBy(props, (value, key) => _.startsWith(key, 'data-'))
	return dataAttributes
}
